import React from "react";
import box from "../../assets/images/box-icon.png";
import shipping from "../../assets/images/shipping.png";
const VendorCard = ({ vendor }) => (
  <div className="vendor-card">
    <div className="vendor-logo">
      <img src={vendor.imageUrl} alt={vendor.vendorName} />
    </div>
    <div className="vendor-content">
      <h3 className="text-high-emphasis">{vendor.vendorName}</h3>
      <ul>
        <li>
          <img src={box} alt="" />
          <span>{vendor.noOfItems} Items</span>
        </li>
        <li>
          <img src={shipping} alt="" />
          <span>{vendor.vLocation}</span>
        </li>
      </ul>
    </div>
  </div>
);
export default VendorCard;
